<template>
  <div id="app">
    <a-locale-provider :locale="zh_CN">
      <router-view/>
    </a-locale-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  data() {
    return {
      zh_CN
    }
  }
}
</script>

<style lang="less">
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font: 14px/1.5 "\u5fae\u8f6f\u96c5\u9ed1", "\5FAE\8F6F\96C5\9ED1", tahoma, arial, "\5b8b\4f53", sans-serif;
  overflow-x: hidden;
}
#app {
  background-color: rgb(239, 239, 239);
}
</style>
